<template>
    <div class="dialog-content" id="dialog-content" ref="chat" :class="{chatEnd: call}" :style="{minHeight: innerHeight + 'px'}">
        <div class="dialog-container" v-for="mes in messagesPrint">
            <div class="dialog" id="dialog">
                <div class="message" v-if="mes.type !=='person'">
                    <div class="avatar" v-if="mes.type !== 'call'">
                        <img src="../../assets/avatar.jpg" alt="">
                    </div>
                    <div :class="{'message-container':mes.type !== 'img'}"
                         v-if="mes.type !== 'call'">
                        <div class="text-container"
                             v-if="mes.type === 'message'||mes.type === 'final'">
                            <p>
                                {{mes.text}}
                            </p>
                        </div>

                        <div class="img-container"
                             v-if="mes.type === 'img'">
                            <img :src="mes.text" alt="">
                        </div>

                        <div class="input"
                             v-if="mes.type === 'question'||mes.type==='questionButton'||mes.type==='gender'"
                             :class="{'genderQuestion':mes.type==='gender'}">

                            <p :class="{'questionText': mes.type==='questionButton'||mes.type==='gender'}">
                                <img :src="mes.smile" alt="" v-if="mes.smile">
                                {{mes.text}}
                            </p>
                            <div class="inputContain" v-if="input && mes.type === 'question'">
                                <div class="inputBlock">
                                    <div class="images" v-show="!focused">
                                        <img src="../../assets/icon_media.svg" alt="">
                                        <img src="../../assets/icon_camera.svg" alt="">
                                        <img src="../../assets/icon_picture.svg" alt="">
                                        <img src="../../assets/icon_microphone.svg" alt="">
                                    </div>
                                    <div class="arrow" v-show="focused">
                                        <img src="../../assets/icon_back-1.svg" alt="">
                                    </div>
                                    <label for="input"
                                           :class="[{'label':!focused},{'labels':focused}]">
                                        <input id="input"
                                               class="user"
                                               type="text"
                                               placeholder="Aa"
                                               v-model="userText"
                                               v-on:focus="focused = true">
                                    </label>
                                    <div class="send">
                                        <button  v-if="focused" v-on:click="sendText" :disabled="!userText" >
                                            <img src="../../assets/icon_send.svg" alt="" id="send">
                                        </button>
                                        <img src="../../assets/icon_like.svg" alt="" v-show="!focused">
                                    </div>

                                </div>
                            </div>

                            <div v-if="mes.answers" class="buttonQustion">
                                <button v-for="ans in mes.answers"
                                        v-on:click="checkAnswer(mes.answers, index)"
                                        :data-text="ans.answer"
                                        :disabled="ans.active"
                                        :class="[{'gender':mes.type==='gender'},{'questionWidth':ans.answer.length>7 && ans.answer.length<23}]">
                                    <img :src="ans.smile" alt="" v-if="ans.smile">
                                    {{ans.answer}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="person" v-if="mes.type ==='person'">
                    <div>
                        <p>
                            {{mes.text}}
                        </p>
                    </div>
                </div>
            </div>
            <div class="btn-container " v-if="mes.type === 'call'">
                <a href="tel:" class="active animated infinite pulse">
                    {{mes.text}}
                </a>
            </div>
        </div>
        <div class="typing" v-if="typing">
            <p>{{userName}} is typing...</p>
        </div>
    </div>
</template>


<script>
    import getCity from '../getCity'

    export default {
        data: () => ({
            call: false,
            defaultSpeed: 6000,
            innerHeight: window.innerHeight,
            messagesPrint: [],
            progress: 0,
            focused: false,
            input: true,
            city:"",
            index: 0,
            area: null,
            userText: '',
            idx: 0,
            typing: true,
            messages: [
                {
                    type: "message",
                    text: "Hello! I am Olivia from {CITY} and I am feeling bored …",
                    who: "manager",
                    city: true
                },
                {
                    type: "message",
                    text: "Maybe we can get to know each other during the hard times in the country.",
                    who: "manager"
                },
                {
                    type: "img",
                    text: require('../../assets/photo1.jpg'),
                    who: "manager",
                },
                {
                    type: "img",
                    text: require('../../assets/photo2.jpg'),
                    who: "manager",
                },
                {
                    type: "message",
                    text: "Here are my photos...",
                    who: "manager",
                },
                {
                    type: "final",
                    text: "let's talk by phone, can you call me now?",
                    who: "manager",
                },
                {
                    type: "call",
                    text: "CALL NOW!",
                    who: "manager",
                    stop: true
                }
            ]
        }),
        props: ['userName'],
        components: {getCity},
        mixins:[getCity],
        methods: {
            bzz() {
                navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;
                if (navigator.vibrate) {
                    navigator.vibrate(200);
                }
            },
            scroll() {

                let height = this.$refs.chat.scrollHeight;
                let chat = this.$refs.chat;

                setTimeout(() => {
                    chat.scrollTo({
                        top: height,
                        behavior: 'smooth'
                    });
                }, 300)
            },
            dialog() {
                this.typing = true;
                let l = setInterval(() => {
                    if (this.messages[this.idx]) {
                        if (this.messages[this.idx].stop) {
                            clearInterval(l);
                            this.typing = false;
                        }
                        if (this.messages[this.idx].type === "img" || this.messages[this.idx].type === "call") {
                            this.bzz();
                        }
                        if(this.messages[this.idx].city){
                            this.messages.splice(this.idx,1,{
                                text: `Hello! I am ${this.userName} from ${this.city} and I am feeling bored …`,
                                who: "manager",
                                type: "message"
                            })
                        }
                        if (this.messages.length === (this.idx + 1)) {
                            clearInterval(l);
                            this.call = true;
                            this.typing = false;
                            // this.$emit('finishChat', 1)
                            setTimeout(() => {
                                this.$emit('finishChat', true)
                            }, 500)
                        }
                        this.scroll();
                        this.messagesPrint.push(this.messages[this.idx]);
                        this.idx++
                    }
                }, this.defaultSpeed)
            },
            sendText(ev) {
                this.scroll();
                this.input = false;
                let index = this.messages[this.idx - 1].type;
                if (index === 'questionButton' || index === 'gender') {
                    let target = ev.target;
                    if (target.tagName === 'BUTTON') {
                        this.userText = target.dataset.text;
                        this.messagesPrint.push({type: 'person', text: this.userText});
                    }
                } else {
                    this.messagesPrint.push({type: 'person', text: this.userText});
                }
                this.dialog();
                this.typing = true;
            }
        },
        checkAnswer(answers, currentIndex) {
            let self = this;
            answers.forEach(function (item, index, array) {
                if (currentIndex !== index) {
                    item.active = true;
                } else {
                    self.sendText(event);
                    item.active = true;
                }
            });
        },
        mounted() {
            this.typing = false;
            window.onresize = () => this.innerHeight = window.innerHeight;

        }
    }

</script>

<style lang="scss" scoped>
    .dialog-content {
        position: relative;
        max-width: 345px;
        margin: 0 auto;
        padding-top: 67px;
        text-align: left;
        padding-bottom: 40px;
        overflow-y: scroll;
        height: 200px;
        -ms-overflow-style: none;
        overflow: -moz-scrollbars-none;
        &::-webkit-scrollbar { width: 0; }

        @media (max-width: 320px) {
            max-width: 298px;
        }

        .message {
            display: flex;
            flex-flow: row nowrap;
            align-items: flex-end;
            margin-bottom: 13px;
        }

        .person {
            display: flex;
            flex-flow: row nowrap;
            justify-content: flex-end;

            div {
                background: #0084FF;
                border-radius: 16px;
                border: none;
                padding: 9px 16px;
                font: 16px/19px Roboto;
                color: white;
                width: fit-content;
                margin-bottom: 14px;
            }
        }

        .avatar {
            img {
                width: 33px;
                height: 33px;
                margin-right: 11px;
                clip-path: circle(16.5px at 50% 50%)
            }
        }

        .message-container {
            max-width: 261px;
            background: #F0F0F0;
            border-radius: 20px;
            font: normal 500 16px/19px Roboto;
            padding: 9px 11px;
            @media (max-width: 320px) {
                padding: 9px 8px;
            }

            .text-container, .input {
                p {
                    font: 16px/19px Roboto;
                }
            }

            .genderQuestion {
                max-width: 205px;
            }

            .time {
                font: normal 500 12px/25px Roboto;
                color: #5B667C;
                padding-top: 5px;

                p {
                    white-space: pre;
                }
            }

            .inputContain {
                position: fixed;
                bottom: 0;
                left: 0;
                box-shadow: 0px -1px 1px rgba(0, 0, 0, 0.1);
                width: 100%;
                height: 46px;


                .inputBlock {
                    padding: 0 12px;
                    display: flex;
                    flex-flow: row nowrap;
                    justify-content: space-between;
                    align-items: center;
                    max-width: 375px;
                    margin: 0 auto;
                    height: 100%;

                    .images {
                        flex-shrink: 0;

                        img {
                            &:not(:last-child) {
                                margin-right: 20px;
                            }
                        }
                    }

                    .send {
                        button {
                            border: none;
                            background: transparent;
                            padding: 0;
                        }

                        [src*="send"] {
                            cursor: pointer;
                            position: relative;
                            top: 2px;
                        }
                    }

                    label {
                        input {
                            height: 33px;
                            border-radius: 16px;
                            border: none;
                            background: #F0F0F0;
                            outline: none;
                            padding: 9px 14px;
                            width: 100%;
                        }

                        &::after {
                            content: ' ';
                            display: block;
                            position: absolute;
                            background: url(../../assets/icon_smile.svg) no-repeat center;
                            background-size: cover;
                            width: 18px;
                            height: 18px;
                            right: 10px;
                            bottom: 7px;
                        }
                    }

                    .label {
                        position: relative;
                        max-width: 175px;
                    }

                    .labels {
                        position: relative;
                        margin: 0 12px;
                        width: 100%;
                    }
                }
            }

            .questionText {
                margin-bottom: 13px;

                img {
                    height: 17px;
                }
            }

            .questionWidth {
                min-width: 239px;
            }

            .buttonQustion {
                text-align: center;
                display: flex;
                flex-flow: row wrap;
                justify-content: space-between;

                .gender {
                    min-width: 205px;
                    cursor: pointer;
                    margin-bottom: 10px;
                    padding: 5px 0;
                }

                button {
                    border-radius: 9px;
                    background: #FFFFFF;
                    text-align: center;
                    color: black;
                    border: none;
                    font: 500 16px/19px Roboto;
                    text-transform: uppercase;
                    cursor: pointer;
                    margin-bottom: 10px;
                    padding: 5px 13px;

                    img {
                        vertical-align: bottom;
                    }
                }
            }
        }

        .typing {
            font: 300 normal 12px/14px Roboto;
            color: #5B5B5B;
            text-align: center;
        }
    }

    .img-container {
        max-width: 228px;
        /*height: 381px;*/
        overflow: hidden;
        border-radius: 16px;

        img {
            max-width: 100%;
        }
    }

    .btn-container {
        text-align: center;

        a, button {
            border: none;
            max-width: 271px;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 70px;
            margin: 0 auto;
            border: white 2px solid;
            border-radius: 320px;
            font: bold 20px /23px Roboto;
            outline: none;
            text-align: center;
            color: #FFFFFF;
            position: relative;
            padding: 11px 20px 11px 60px;
            text-transform: uppercase;
            background: #0084FF;
            text-decoration: none;

            &::before {
                content: '';
                display: block;
                position: absolute;
                background: url(../../assets/icon_button_call.svg) no-repeat;
                width: 42px;
                height: 42px;
                left: 20px;
                bottom: 13px;
                animation: infinite tada 1.2s;
            }
        }
    }

    .chatEnd {
        padding-bottom: 80px;
    }
</style>